import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Image } from 'components';

const IconsAlignerService = ({ className }) => (
  <div className={cx('section-icons-aligner', [className])}>
    <h2 className='section-icons-title t-center mb-10'>
      Raising the standards for teledentistry
    </h2>
    <p className='t-center mb-40'>Safe treatment & guaranteed results with no hidden costs</p>

    <div className='section-icons'>
      <div className='icon-wrapper'>
        <Image url='icons/icon_shipping.svg' alt='Free global shipping' />
        <p><b>Free worldwide shipping</b></p>
      </div>
      <div className='icon-wrapper'>
        <Image url='icons/icon_guarantees.svg' alt='Industry leading guarantees' />
        <p><b>Industry leading guarantees</b></p>
      </div>
      <div className='icon-wrapper'>
        <Image url='icons/icon_led.svg' alt='Unmatched clinical expertise' />
        <p><b>Unmatched clinical expertise</b></p>
      </div>
      <div className='icon-wrapper'>
        <Image url='icons/icon_clock.svg' alt='Full customer support' />
        <p><b>Round the clock customer support</b></p>
      </div>
    </div>
  </div>
);

IconsAlignerService.propTypes = {
  className: PropTypes.string.isRequired,
};

IconsAlignerService.defaultProps = {
  className: '',
};

export default IconsAlignerService;
